export default function Marquee({ items }) {
    const row = items.map((t) => `${t}\u2003·\u2003`).join("");
    return (
        <div
            className="overflow-hidden border-y border-linedark bg-ink py-5"
            aria-hidden="true"
            data-testid="editorial-marquee"
        >
            <div className="marquee-track flex w-max whitespace-nowrap font-display text-sm font-medium uppercase tracking-[0.35em] text-cream/60">
                <span>{row}</span>
                <span>{row}</span>
            </div>
        </div>
    );
}
